import React, { FC, useState, useEffect, useRef } from "react";
import styles from "./styles.module.scss";
import { Props } from "./typings";
import { useOnClickOutside } from "usehooks-ts";
import NotFoundScreen from "components/NotFoundScreen";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

const DropdownInput: FC<Props> = ({
  toggle,
  onClick,
  items,
  RightIcon,
  onRightClick,
  isLoading,
  title,
  subClass,
}) => {
  const { t } = useTranslation();
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const listRef = useRef<HTMLDivElement>(null);

  const handleKeyDown = (event) => {
    switch (event.key) {
      case "ArrowDown":
        setFocusedIndex((prevIndex) =>
          prevIndex < items.length - 1 ? prevIndex + 1 : prevIndex
        );
        break;
      case "ArrowUp":
        setFocusedIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : 0));
        break;
      case "Enter":
        if (focusedIndex >= 0) {
          onClick(items[focusedIndex].id);
        }
        break;
      case "Escape":
        toggle();
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [focusedIndex, items]);

  useEffect(() => {
    if (listRef.current && focusedIndex >= 0) {
      const wrapper = listRef.current.children[0];
      const item = wrapper.children[focusedIndex];
      if (item) {
        item.scrollIntoView({ block: "nearest" });
        (item as HTMLDivElement).focus();
      }
    }
  }, [focusedIndex]);

  useOnClickOutside(listRef, () => {
    toggle();
  });

  return (
    <div className={styles.list} ref={listRef}>
      {title && <div className={styles.title}>{title}</div>}
      <div className={styles.listWrapper}>
        {items?.map((item, index) => (
          <div
            onClick={() => {
              console.log("clicked");
              onClick(item.id);
            }}
            key={item.id}
            className={`${styles.box} ${
              index === focusedIndex ? styles.focus : ""
            }`}
            tabIndex={-1}
          >
            <div className={styles.col1}>
              <div title={item.title} className={styles.client}>
                {item.title}
              </div>
              <div className={classNames(styles.title, subClass)}>
                {item.sub}
              </div>
            </div>
            <div className={styles.col2}>
              {onRightClick && (
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    onRightClick?.(item.id);
                  }}
                >
                  {RightIcon}
                </div>
              )}
            </div>
          </div>
        ))}
        {items && items.length === 0 && !isLoading && (
          <div className={styles.empty}>
            <NotFoundScreen
              size="medium"
              title={t("common.noItems")}
              text={t("common.addNewToStart")}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DropdownInput;
